export const GET_ORDERS = "GET_ORDERS";
export const CANCEL_ORDER = "CANCEL_ORDER";
export const NEW_ORDER="NEW_ORDER";
export const BOOKING_POS_RESPONSE="BOOKING_POS_RESPONSE";
export const CANCEL_BOOKING="CANCEL_BOOKING";
